import { allRoles, isAuthorized, lazyLoadView } from '@/router/routing'
import type { Route, RouteConfig } from 'vue-router'

export const composablesRoutes: RouteConfig[] = [
  {
    path: 'ui-use-error-logging',
    name: 'ui-use-error-logging',
    component: () => lazyLoadView(import('@/ui-kit/views/plugins/UiKitUseErrorLoggingView.vue')),
    meta: {
      title: 'UseErrorLogging',
      is_authorized: (route: Route) => isAuthorized(route),
      requires_auth: true,
      requires_tenant: true,
      requires_role: allRoles,
      doc_id: 'ui-use-error-logging',
    },
  },
  {
    path: 'ui-use-event-tracking',
    name: 'ui-use-event-tracking',
    component: () => lazyLoadView(import('@/ui-kit/views/plugins/UiKitUseEventTrackingView.vue')),
    meta: {
      title: 'UseEventTracking',
      is_authorized: (route: Route) => isAuthorized(route),
      requires_auth: true,
      requires_tenant: true,
      requires_role: allRoles,
      doc_id: 'ui-use-event-tracking',
    },
  },
  {
    path: 'ui-use-api',
    name: 'ui-use-api',
    component: () => lazyLoadView(import('@/ui-kit/views/plugins/UiKitUseApiView.vue')),
    meta: {
      title: 'UseApi',
      is_authorized: (route: Route) => isAuthorized(route),
      requires_auth: true,
      requires_tenant: true,
      requires_role: allRoles,
      doc_id: 'ui-use-api',
    },
  },
  {
    path: 'ui-use-search',
    name: 'ui-use-search',
    component: () => lazyLoadView(import('@/ui-kit/views/plugins/UiKitUseSearchView.vue')),
    meta: {
      title: 'UseSearch',
      is_authorized: (route: Route) => isAuthorized(route),
      requires_auth: true,
      requires_tenant: true,
      requires_role: allRoles,
      doc_id: 'ui-use-search',
    },
  },
  {
    path: 'ui-form-validation',
    name: 'ui-form-validation',
    component: () => lazyLoadView(import('@/ui-kit/views/plugins/UiKitFormValidationView.vue')),
    meta: {
      title: 'UseFormValidation',
      is_authorized: (route: Route) => isAuthorized(route),
      requires_auth: true,
      requires_tenant: true,
      requires_role: allRoles,
      doc_id: 'ui-form-validation',
    },
  },
  {
    path: 'ui-use-reactive-set',
    name: 'ui-use-reactive-set',
    component: () => lazyLoadView(import('@/ui-kit/views/plugins/UiKitUseReactiveSetView.vue')),
    meta: {
      title: 'UseReactiveSet',
      is_authorized: (route: Route) => isAuthorized(route),
      requires_auth: true,
      requires_tenant: true,
      requires_role: allRoles,
      doc_id: 'ui-use-reactive-set',
    },
  },
  {
    path: 'ui-use-edit-mixin-form-validation',
    name: 'ui-use-edit-mixin-form-validation',
    component: () => lazyLoadView(import('@/ui-kit/views/plugins/UiKitUseEditMixinFormValidationView.vue')),
    meta: {
      title: 'UseEditMixinFormValidation',
      is_authorized: (route: Route) => isAuthorized(route),
      requires_auth: true,
      requires_tenant: true,
      requires_role: allRoles,
      doc_id: 'ui-use-edit-mixin-form-validation',
    },
  },
  {
    path: 'ui-use-confirm-dialog',
    name: 'ui-use-confirm-dialog',
    component: () => lazyLoadView(import('@/ui-kit/views/plugins/UiKitUseConfirmDialogView.vue')),
    meta: {
      title: 'UseConfirmDialog',
      is_authorized: (route: Route) => isAuthorized(route),
      requires_auth: true,
      requires_tenant: true,
      requires_role: allRoles,
      doc_id: 'ui-use-confirm-dialog',
    },
  },
  {
    path: 'ui-use-client-datatable',
    name: 'ui-use-client-datatable',
    component: () => lazyLoadView(import('@/ui-kit/views/plugins/UiKitUseClientDatatableView.vue')),
    meta: {
      title: 'UseClientDatatable',
      is_authorized: (route: Route) => isAuthorized(route),
      requires_auth: true,
      requires_tenant: true,
      requires_role: allRoles,
      doc_id: 'ui-use-client-datatable',
    },
  },
]
